var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.388672,
    y: 0.854004,
    width: 45.1398,
    height: 47.2194,
    rx: 10,
    fill: "#0066F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2852 10.7373H23.4722C30.5542 10.7373 36.296 16.8833 36.296 24.4639C36.296 32.0444 30.5548 38.1904 23.4722 38.1904C16.3897 38.1904 10.6484 32.0444 10.6484 24.4639C10.6486 23.2409 10.8013 22.0234 11.1023 20.8436L12.108 18.8823H23.4722C25.9194 18.8809 28.0378 20.7025 28.564 23.2608C29.0902 25.819 27.8824 28.4245 25.6609 29.5233C23.4394 30.6221 20.8029 29.9183 19.3237 27.8314C17.8445 25.7446 17.9213 22.8372 19.5082 20.8431H17.1307C15.6108 23.8933 16.1788 27.6543 18.5192 30.0365C20.8597 32.4187 24.3974 32.8368 27.167 31.0585C29.9366 29.2803 31.2575 25.7426 30.3959 22.4109C29.5343 19.0792 26.7019 16.7721 23.4722 16.7714H13.1912L14.1963 14.8112H23.4722C27.438 14.8113 30.9384 17.5843 32.0972 21.6439C33.2561 25.7035 31.8015 30.0972 28.5132 32.4699C25.2248 34.8426 20.8742 34.6376 17.7933 31.9648C14.7124 29.292 13.6241 24.7786 15.1117 20.8436H13.0132C12.6596 22.0131 12.4798 23.2347 12.4803 24.4639C12.4803 30.9614 17.402 36.2296 23.4722 36.2296C29.5425 36.2296 34.4637 30.962 34.4637 24.4639C34.4637 17.9658 29.5409 12.6981 23.4722 12.6981H15.2795L16.2714 10.7641L16.2852 10.7373Z",
    fill: "#F6F6F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoyLogo);
export default __webpack_public_path__ + "static/media/coy-logo.caa8822b9674b03f37eff8e515e994d0.svg";
export { ForwardRef as ReactComponent };